var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingCompleteSuccessFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 169,
    viewBox: "0 0 310 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7043 118.118H162.804",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4312 126.13H97.6733",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.689 168H293.067",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M244.994 15.5098L282.729 15.5098",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.733 8.78998H308.833",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.354 62.5486H85.2674",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.4368,
    y: 27.3972,
    width: 5.21456,
    height: 137.71,
    rx: 2.60728,
    transform: "rotate(-7.05387 90.4368 27.3972)",
    fill: "#307FE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.0923,
    y: 30.6386,
    width: 122.343,
    height: 75.2014,
    transform: "rotate(-7.05387 96.0923 30.6386)",
    fill: "#FFBE9F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161.418,
    cy: 60.4425,
    r: 22.6845,
    transform: "rotate(-7.05387 161.418 60.4425)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.555 62.2192L161.622 70.622L180.693 44.2291",
    stroke: "#307FE2",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M280.778 93.563L285.688 112.689",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.37 99.3846L274.096 106.865",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.13 94.5522L278.336 111.698",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.282 107.075L274.184 99.1762",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9104 135.95L25.8112 148.021",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5945 139.625L33.1278 144.345",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2703 136.576L30.4513 147.397",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6501 144.479L33.0717 139.493",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M251.87 149.648C223.225 164.168 207.685 145.272 215.067 133.117C220.382 124.365 228.136 133.117 219.778 138.964C209.322 146.279 199.066 136.598 201.044 125.33",
    stroke: "#83B2EE",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M296.957 50.6591C294.316 77.9389 269.798 70.273 265.778 60.0917C261.981 50.476 271.479 44.8374 275.293 54.9378C279.107 65.0382 260.62 77.502 249.554 66.7803",
    stroke: "#83B2EE",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08338 19.3022C-2.03933 46.3978 23.609 44.9723 30.0013 36.0863C36.0385 27.694 28.2114 19.9002 22.0389 28.7583C15.8664 37.6164 30.7366 54.2298 44.0919 46.5459",
    stroke: "#83B2EE",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M246.545 33.5527L271.571 2.7704",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5659 104.811L22.5291 121.4",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M265.154 30.2013L291.977 11.9152",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.385 99.6118L8.24715 104.194",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingCompleteSuccessFlag);
export default __webpack_public_path__ + "static/media/onboarding_complete_success_flag.2aed54a62b6797706efe18247b2486b4.svg";
export { ForwardRef as ReactComponent };